import {AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Observable} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {EChartsOption} from 'echarts';
import {ColDef, ICellRendererParams} from '@ag-grid-community/core';
import {AdRRequestParams} from '../../classes/ad-r-request-params';
import {MetricComponentObject} from '../../classes/metric-component-object';
import {Site} from '../../interfaces/site';
import {Serializer} from '../../interfaces/serializer';
import {AdRequestOptions} from "../../interfaces/ad-reports";
import {ReportTableTrendsDialogStore} from '../../store/report/report-table-trends-dialog.store';

@Component({
  selector: 'app-trends-dialog',
  templateUrl: './trends-dialog.component.html',
  styleUrls: ['./trends-dialog.component.scss'],
  providers: [ReportTableTrendsDialogStore]
})
export class TrendsDialogComponent implements OnInit, AfterViewInit, OnDestroy {
  public readonly defaultColDef: any = {
    resizable: true,
    suppressNavigable: true,
    suppressCellSelection: true,
    menuTabs: ['filterMenuTab'],
    filterParams: {
      buttons: ['reset']
    }
  };

  public readonly gridOptions: any = {
    suppressDragLeaveHidesColumns: true,
    rowHeight: 35,
    groupHeaderHeight: 35,
    headerHeight: 35
  };

  public readonly columnDefs: Array<ColDef> = [
    {
      lockPosition: true,
      field: 'day',
      sortable: false,
      filter: 'agTextColumnFilter',
      headerValueGetter: _ => this.translateS.instant('reports.date')
    },
    {
      lockPosition: true,
      field: 'value',
      sortable: true,
      filter: 'agNumberColumnFilter',
      headerValueGetter: _ => this.translateS.instant('reports.value'),
      valueFormatter: value => value.data.formatted_value
    }
  ];

  public readonly loading$: Observable<boolean> = this._reportTableTrendsDialogStore.loading$;
  public readonly rows$: Observable<Array<{ day: string, value: string, formatted_value: string }>> = this._reportTableTrendsDialogStore.rows$;
  public readonly chartOption$: Observable<EChartsOption> = this._reportTableTrendsDialogStore.chartOption$;
  public readonly dimension$: Observable<string> = this._reportTableTrendsDialogStore.dimension$;

  constructor(
    public readonly dialogRef: MatDialogRef<TrendsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: ICellRendererParams & {
      dataset: Serializer<Site>,
      colDef: ColDef & { params: { metric: MetricComponentObject } }
      params: Partial<AdRRequestParams>,
      uuid: string | null,
      token: string | null,
      options: Partial<AdRequestOptions>
    },
    private readonly translateS: TranslateService,
    private readonly _reportTableTrendsDialogStore: ReportTableTrendsDialogStore
  ) {}
  ngOnInit(): void {}

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}

}
